import React from 'react'
import HeadingNew from 'presentation/shared/components/HeadingNew'
import ResponsiveModal from 'presentation/shared/components/ResponsiveModal'
import * as S from './styles'
import { Patient } from 'domain/entities/patient-model'
import SupportTextNew from 'presentation/shared/components/SupportTextNew'
import moment from 'moment-timezone'
import { formatCpf } from 'common/utils/format-cpf'
import { isPatientRN } from 'presentation/utils/validators/is-patient-rn'

type SelectPatientResponsiveModalProps = {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  patient: Patient | null
}

const SelectPatientResponsiveModal = ({
  isOpen,
  onClose,
  onConfirm,
  patient
}: SelectPatientResponsiveModalProps) => {
  const handleClose = () => onClose()

  const handleConfirm = () => {
    onConfirm && onConfirm()
  }

  const isRN = isPatientRN(moment(patient?.birthday).utc().toDate())

  return (
    <ResponsiveModal
      isOpen={isOpen}
      title="Confirmar seleção de paciente"
      onClose={handleClose}
      onConfirm={handleConfirm}
      confirmButtonLabel="Prosseguir com este paciente"
      cancelButtonLabel="Fazer outra busca"
    >
      {(isMobile) => (
        <div>
          <HeadingNew
            size={isMobile ? 'medium' : 'large'}
            color="textPrimary"
            fontFamily="secondary"
          >
            Sua busca retornou o seguinte paciente:
          </HeadingNew>
          <SupportTextNew
            color="textSecondary"
            fontFamily="secondary"
            style={{ marginTop: isMobile ? '8px' : '16px' }}
          >
            Confirme os dados cadastrais antes de prosseguir com a criação do
            pedido. Caso algum dados esteja divergente, crie um novo cadastro
            para o seu paciente:
          </SupportTextNew>
          <S.Card>
            <S.CardHeader>
              {isRN && <S.BadgeRN />}
              <S.Info>
                <SupportTextNew as="span" weight="semiBold" size="xxsmall">
                  Paciente
                </SupportTextNew>
                <HeadingNew
                  as="h4"
                  weight="bold"
                  size="large"
                  color="textPrimary"
                >
                  {patient?.name}
                </HeadingNew>
              </S.Info>
            </S.CardHeader>
            <div
              style={{
                display: 'flex',
                flexDirection: isMobile ? 'column' : 'row',
                gap: isMobile ? '8px' : '16px'
              }}
            >
              <S.Info>
                <SupportTextNew as="span" weight="semiBold" size="xxsmall">
                  Data de nascimento {isRN && 'RN'}
                </SupportTextNew>
                <HeadingNew
                  as="h6"
                  weight="bold"
                  size="medium"
                  color="textPrimary"
                >
                  {moment(patient?.birthday).utc().format('DD/MM/YYYY')}
                </HeadingNew>
              </S.Info>
              <S.Info style={{ marginLeft: isMobile ? 0 : '72px' }}>
                <SupportTextNew as="span" weight="semiBold" size="xxsmall">
                  CPF {isRN && 'da mãe'}
                </SupportTextNew>
                <HeadingNew
                  as="h6"
                  weight="bold"
                  size="medium"
                  color="textPrimary"
                >
                  {isRN
                    ? !!patient?.tutor?.cpf && formatCpf(patient?.tutor?.cpf)
                    : !!patient?.user?.cpf && formatCpf(patient?.user?.cpf)}
                </HeadingNew>
              </S.Info>
            </div>
          </S.Card>
        </div>
      )}
    </ResponsiveModal>
  )
}

export default SelectPatientResponsiveModal
